import React, {Component} from 'react';
import s from './index.module.scss';
import i18next from 'i18next';

import {http} from '../../common/request';
import {message} from 'antd';

import {connect} from 'react-redux';
import actions from '../../redux/action';
import {getQueryVariable} from '../../common/util';
import MobileAuth from '../login/mobile/Auth';

class Consent extends Component {
    constructor(props) {
        super(props);
        const userAgent = navigator.userAgent || navigator.vendor || '';
        this.state = {
            access_key: '', cid: '', code: 1, scopes: [], scopes_cn: [], scopes_en: [], redirectUrl: '',
            isPhone: !!userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i),
        };
    }

    formRef = React.createRef();

    componentDidMount() {
        const access_key = getQueryVariable('access_key');
        const cid = getQueryVariable('cid');
        const scopes_arr = decodeURI(getQueryVariable('scopes')).split('||');
        const scopes = scopes_arr[0].split('|');
        let scopes_en = scopes_arr[1].split('|');
        const scopes_cn = scopes_arr[2].split('|');

        scopes_en = scopes_en.map(item => {
            return item.split('_').join(' ');
        });

        if (access_key) {
            this.setState({
                access_key, cid, scopes, scopes_en, scopes_cn,
            }, () => {
                console.log(this.state, 'state in consent');
                this.consentRedirects();
            });
        }
    }

    //获取两个重定向的url
    async consentRedirects() {
        const { cid } = this.state;
        const params = {
            cid,
        };
        const res = await http('get', '/account/oauthUris', params).catch((err) => {
        });
        if (res && res.data && res.data.code === 0) {

            if (res.data.data.consent) {
                this.setState({
                    redirectUrl: res.data.data.consent,
                });
            }
            console.log(res, 'res in consentRedirects');

        } else {
            message.warn(res.data.desc);
        }
    }

    //请求OAuth
    submit(code) {

        this.setState({
            code,
        }, () => {
            document.getElementById('form').submit();
        });

    }


    render() {
        const { locale } = this.props;
        const { access_key, cid, code, scopes, scopes_en, scopes_cn, redirectUrl, isPhone } = this.state;
        const scopes_temp = locale === 'en' ? scopes_en : scopes_cn;

        return (<div>
            {
                isPhone ? <MobileAuth
                        onConsent={ () => this.submit(0) }
                        onCancel={ () => this.submit(1) }
                    /> :
                    <div className={ s.container }>
                        <div className={ s.welcome }>
                            { i18next.t('home_title') }
                        </div>

                        <div className={ s.content }>
                            <div className={ s.title }>
                                { i18next.t('consent_title') }
                            </div>
                            { scopes_temp && scopes_temp.length > 0 ? scopes_temp.map((scope, index) => {
                                return <div type="checkbox" name="scopes" disabled checked className={ s.scope }
                                            key={ index }>{ scope }</div>;
                            }) : null }
                        </div>

                        <div className={ s.consent }></div>
                        <div className={ s.buttons }>
                            <div className={ s.cancel } onClick={ () => this.submit(1) }>
                                { i18next.t('cancel') }
                            </div>
                            <div className={ s.submit } onClick={ () => this.submit(0) }>
                                { i18next.t('consent') }
                            </div>
                        </div>
                    </div>
            }

            <form style={ { display: 'none' } } action={ redirectUrl } method="POST" id="form">
                <input type="hidden" id="access_key" name="access_key" value={ access_key }/>
                <input type="hidden" id="cid" name="cid" value={ cid }/>
                <input type="hidden" id="code" name="code" value={ code }/>
                { scopes && scopes.length > 0 ? scopes.map((scope, index) => {
                    return (<input type="hidden" id={ `scope${ index }` } name={ `scopes[]` } value={ scope }/>);
                }) : null }
            </form>

        </div>);
    }
}

const mapStateToProps = state => ({
    locale: state.language.language,
});
const mapDispatchToProps = dispatch => ({
    changeLanguage: val => dispatch(actions.onChangeLanguage(val)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Consent);
